import isurveys from './modules/i-surveys'
import base from './modules/base'
import meeting from './modules/meeting'
import activity from './modules/activity'
export default [
  ...base,
  ...meeting,
  ...activity,
  isurveys,
]
